import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Link } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  const toggleMobileMenu = (e) => {
    e.preventDefault();
    setMobileMenuOpen(!mobileMenuOpen);
    setActiveSubmenu(null);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setActiveSubmenu(null);
  };

  const toggleSubmenu = (menuName, e) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveSubmenu(activeSubmenu === menuName ? null : menuName);
  };

  const MobileNavLink = ({ to, children, ...props }) => (
    <Link to={to} onClick={closeMobileMenu} {...props}>
      {children}
    </Link>
  );

  const MobileExternalLink = ({ href, children, ...props }) => (
    <a href={href} onClick={closeMobileMenu} {...props}>
      {children}
    </a>
  );

  return (
    <>
      <div id="header-container" className="container-fluid">
        <div className="container xlarge-container">
          <div>
            <div>
              <Link to="/" onClick={closeMobileMenu}>
                <LazyLoadImage src="/img/logo.svg" alt="Redemption Psychiatry" effect="blur" />
              </Link>
            </div>
            <div>
              <ul>
                <li>
                  <Link to="/services">Our Services</Link>
                  <ul className="sub-menu">
                    <li><Link to="/med-management">Medication Management</Link></li>
                    <li><Link to="/tms">TMS Therapy</Link></li>
                    <li><Link to="/ketamine">Ketamine Treatments</Link></li>
                    <li><Link to="/adhd-testing">ADHD Testing</Link></li>
                  </ul>
                </li>
                <li><Link to="/resources">Resources & Learning</Link></li>
                <li>
                  <Link to="/about">About Us</Link>
                  <ul className="sub-menu">
                    <li><Link to="/about">Redemption Psychiatry</Link></li>
                    <li><Link to="/provider-biographies">Our Team</Link></li>
                  </ul>
                </li>
                <li className="menu-item-has-children">
                  <Link to="/contact">Contact Us</Link>
                  <ul className="sub-menu">
                    <li><Link to="/contact">Contact Us</Link></li>
                    <li><Link to="https://recruiting.paylocity.com/recruiting/jobs/All/954f045d-735f-4e04-8ec7-216c4991e050/Redemption-Psychiatry">Careers</Link></li>
                  </ul>
                </li>
                <li><a href="https://www.valant.io/myio/rp/login" className="button blue-border" target="_blank" rel="noopener noreferrer">Patient Login</a></li>
                <li><Link to="/newpatients" className="button blue-border">New Patients</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <button id="mobile-menu-icon" style={{ border: 'none', background: '#ffffff' }} onClick={toggleMobileMenu}>
          <LazyLoadImage src="/img/icon-menu.svg" alt="Menu" effect="blur" />
        </button>
      </div>

      <div id="mobile-menu" className={mobileMenuOpen ? 'is-visible' : ''}>
        <ul>
          <li className="menu-item-has-children">
            <a href="#" onClick={(e) => toggleSubmenu('services', e)}>
              Our Services
              <span className={`submenu-arrow ${activeSubmenu === 'services' ? 'open' : ''}`}>▼</span>
            </a>
            <ul className={`sub-menu ${activeSubmenu === 'services' ? 'show' : ''}`}>
              <li><MobileNavLink to="/med-management">Medication Management</MobileNavLink></li>
              <li><MobileNavLink to="/tms">TMS Therapy</MobileNavLink></li>
              <li><MobileNavLink to="/ketamine">Ketamine Treatments</MobileNavLink></li>
              <li><MobileNavLink to="/adhd-testing">ADHD Testing</MobileNavLink></li>
            </ul>
          </li>
          <li><MobileNavLink to="/resources">Resources & Learning</MobileNavLink></li>
          <li className="menu-item-has-children">
            <a href="#" onClick={(e) => toggleSubmenu('about', e)}>
              About Us
              <span className={`submenu-arrow ${activeSubmenu === 'about' ? 'open' : ''}`}>▼</span>
            </a>
            <ul className={`sub-menu ${activeSubmenu === 'about' ? 'show' : ''}`}>
              <li><MobileNavLink to="/about">Redemption Psychiatry</MobileNavLink></li>
              <li><MobileNavLink to="/provider-biographies">Our Team</MobileNavLink></li>
            </ul>
          </li>
          <li className="menu-item-has-children">
            <a href="#" onClick={(e) => toggleSubmenu('contact', e)}>
              Contact Us
              <span className={`submenu-arrow ${activeSubmenu === 'contact' ? 'open' : ''}`}>▼</span>
            </a>
            <ul className={`sub-menu ${activeSubmenu === 'contact' ? 'show' : ''}`}>
              <li><MobileNavLink to="/contact">Contact Us</MobileNavLink></li>
              <li><MobileExternalLink href="https://recruiting.paylocity.com/recruiting/jobs/All/954f045d-735f-4e04-8ec7-216c4991e050/Redemption-Psychiatry">Careers</MobileExternalLink></li>
            </ul>
          </li>
          <li>
            <MobileExternalLink
              href="https://www.valant.io/myio/rp/login"
              className="button blue-border"
              target="_blank"
              rel="noopener noreferrer"
            >
              Patient Login
            </MobileExternalLink>
          </li>
          <li>
            <MobileNavLink to="/newpatients" className="button light-blue">
              New Patients
            </MobileNavLink>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Header;
